import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { useNavigate } from "react-router-dom";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";

import { useState } from "react";
import usePagination from "../../hooks/usePagination";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import PhotoGalleryDetail from "../Home/PhotoVideoPublication/Photos/PhotoGalleryDetail";
import EventsDetail from "../Home/Events/EventsDetail";

const PhotoGalleryAndEvents = () => {
  const [active, setActive] = useState("current-events");
  const { getText } = useLanguageTranslation();

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("News Room & Media", "समाचार मीडिया")}
        titleTwo={getText("Photo Gallery", "फोटो गैलरी")}
        titleLink="/news-room-media/photo-gallery"
        levelTwo={true}
        levelThree={false}
        isActive={getText("Photo Gallery", "फोटो गैलरी")}
      />

      {/* <div className="inner-container">
        <div className="container">
          <div className="container gallery-events">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
                <section className="leftmenu-hori">
                  <ul>
                    <li className={active === "current-events" ? "active" : ""}>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setActive("current-events");
                        }}
                      >
                        <div className="icon icon-event"></div>
                        {getText("Current Events", "BEE चित्रकला")}
                      </a>
                    </li>
                    <li className={active === "photo-gallery" ? "active" : ""}>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setActive("photo-gallery");
                        }}
                      >
                        <div className="icon icon-gallery"></div>
                        {getText("Photo Gallery", "अन्य समारोह")}
                      </a>
                    </li>
                  </ul>
                </section>
              </div>
            </div>

            {active === "current-events" && <EventsDetail />}
            {active === "photo-gallery" && <PhotoGalleryDetail />}
          </div>
        </div>
      </div> */}
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <PhotoGalleryDetail />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default PhotoGalleryAndEvents;
